export default __webpack_public_path__ + "ede6482cb933ba8f454fa1e97307ef83.png";